












import { Component, ModelSync, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FormCheckbox extends Vue {
    @Prop(String) readonly id!: string;

    @Prop(String) readonly label!: string;

    @ModelSync('value', 'change', { type: Boolean })
    readonly formValue!: boolean;
}
